import packageJson from '../../package.json';

export const defaultEnvironmentConfigs = {
  version: packageJson.version,
  production: true,
  apiUrl: '/',
  ssoUrl: 'https://local-device-management.scm3d.com:6002',
  ssoAuthUrl: '/auth/google',
  ssoSilentAuthUrl: '/auth/silent/refresh/',
  ssoLogoutUrl: '/auth/logout',
  ssoSilentAuthReturnMessage: 'Successfully Authenticated'
};
